// ============================================================
// HABIT OS — Bibliothek: Sport & Bewegung
// ============================================================

export const LIBRARY_SPORT = {
  id: "sport",
  label: "Sport",
  icon: "💪",
  subcategories: [
    {
      id: "sport_strength",
      label: "Kraft",
      icon: "🏋️",
      habits: [
        {
          id: "hab_resistance_training",
          label: "Krafttraining 3–4x pro Woche",
          time: "flexible",
          icon: "🏋️",
          why: "Regelmäßiges Krafttraining erhält Muskelmasse und Knochendichte, besonders im Alter.",
          source: "Attia P., Outlive, 2023 · Westcott WL, Current Sports Medicine Reports, 2012",
          dose: "3–4 Einheiten à 45–60 Min., progressive Überlastung als Kernprinzip",
        },
        {
          id: "hab_grip_strength",
          label: "Griffkraft-Training (Dead Hangs)",
          time: "flexible",
          icon: "✊",
          why: "Griffkraft gilt in Studien als Marker für die allgemeine körperliche Fitness. Dead Hangs trainieren die Griffkraft und entlasten nach langem Sitzen die Wirbelsäule.",
          source: "Leong et al., The Lancet, 2015 · Attia P., Outlive, 2023",
          dose: "3x pro Woche: Dead Hangs 3 × max. Zeit, oder Farmer Carries 20–30 m",
        },
        {
          id: "hab_compound_lifts",
          label: "Big 5 Compound-Übungen",
          time: "flexible",
          icon: "🔩",
          why: "Mehrgelenksübungen trainieren viele Muskelgruppen gleichzeitig.",
          source: "Schoenfeld BJ, Journal of Strength and Conditioning Research, 2010",
          dose: "3–4 Sätze à 5–8 Wiederholungen, 2–3 Min. Pause zwischen den Sätzen",
        },
      ],
    },
    {
      id: "sport_cardio",
      label: "Cardio & Ausdauer",
      icon: "🏃",
      habits: [
        {
          id: "hab_zone2",
          label: "Zone 2 Cardio (3–4 Std. pro Woche)",
          time: "flexible",
          icon: "🚴",
          why: "Moderates Ausdauertraining, bei dem man sich noch unterhalten kann, verbessert die Grundlagenausdauer.",
          source: "Attia P., Outlive, 2023 · Holloszy & Coyle, Journal of Applied Physiology, 1984",
          dose: "45–60 Min., 3–4x pro Woche, bei ~60–70% maximaler Herzfrequenz",
        },
        {
          id: "hab_hiit",
          label: "VO2max-Training (4×4 HIIT)",
          time: "flexible",
          icon: "🔥",
          why: "VO2max beschreibt die maximale Sauerstoffaufnahme und gilt als wichtiger Marker der Ausdauerfitness. Die norwegische 4×4-Methode ist eine verbreitete Form des Intervalltrainings.",
          source: "Attia P., Outlive, 2023 · Mandsager et al., JAMA Network Open, 2018",
          dose: "1–2× pro Woche Intervalle. Bei Vorerkrankungen oder wenig Trainingserfahrung vorher ärztlich abklären.",
        },
        {
          id: "hab_morning_walk",
          label: "Morgendlicher Spaziergang (10–30 Min.)",
          time: "morning",
          icon: "🚶",
          why: "Ein morgendlicher Spaziergang setzt den zirkadianen Rhythmus durch Sonnenlicht, aktiviert den Bewegungsapparat und produziert messbare Dopamin- und Serotonin-Ausschüttung. Huberman bezeichnet es als 'die wichtigste einzelne Gewohnheit' in seinem Protokoll.",
          source: "Huberman Lab, Episode 1 · Mead MN, Environmental Health Perspectives, 2008",
          dose: "10–30 Min. draußen, idealerweise ohne Sonnenbrille für maximale Lichtwirkung",
        },
      ],
    },
    {
      id: "sport_mobility",
      label: "Mobility & Recovery",
      icon: "🧘",
      habits: [
        {
          id: "hab_nsdr",
          label: "NSDR / Yoga Nidra (10–20 Min.)",
          time: "flexible",
          icon: "😌",
          why: "Geführte Tiefenentspannung (Yoga Nidra) kann helfen, zur Ruhe zu kommen. Sie ersetzt keinen Schlaf.",
          source: "Huberman Lab, Episode 57 · Kjaer et al., Cognitive Brain Research, 2002",
          dose: "10–20 Min. täglich, idealerweise nach dem Mittagessen oder Post-Training",
        },
        {
          id: "hab_cold_exposure",
          label: "Kältereiz (Kaltdusche / Eisbad)",
          time: "morning",
          icon: "🧊",
          why: "Kaltes Wasser wirkt stark aktivierend und wird von vielen als erfrischend erlebt.",
          source: "Søberg et al., Cell Metabolism, 2021 · Huberman Lab, Episode 66",
          dose: "Mit 15–30 Sek. kaltem Abschluss beim Duschen beginnen. Bei Herz-Kreislauf-Erkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_stretching",
          label: "Statisches Stretching (abends)",
          time: "night",
          icon: "🤸",
          why: "Ruhiges Dehnen am Abend kann die Beweglichkeit verbessern und beim Runterfahren helfen.",
          source: "Herbert & Gabriel, BMJ, 2002 · Apostolopoulos et al., Journal of Bodywork, 2015",
          dose: "10–15 Min. täglich abends: Hüftbeuger, Ischiokrurale, Brustöffner je 60 Sek. halten",
        },
      ],
    },
  ],
};


// ============================================================
// HABIT OS — Bibliothek: Mind & Kognition
// ============================================================

export const LIBRARY_MIND = {
  id: "mind",
  label: "Mind",
  icon: "🧠",
  subcategories: [
    {
      id: "mind_meditation",
      label: "Meditation & Achtsamkeit",
      icon: "🧘",
      habits: [
        {
          id: "hab_meditation",
          label: "Fokussierte Meditation (13 Min.)",
          time: "morning",
          icon: "🧘",
          why: "Bereits 13 Minuten geführte Meditation täglich über 8 Wochen verbessern Arbeitsgedächtnis, Leseverständnis und emotionale Regulation signifikant. Neuroimaging zeigt strukturelle Veränderungen im präfrontalen Kortex und Hippocampus.",
          source: "Rahl et al., Psychological Science, 2010 · Lazar et al., NeuroReport, 2005",
          dose: "13 Min. täglich, morgens — Apps: Waking Up (Sam Harris), Headspace",
        },
        {
          id: "hab_breathing",
          label: "Physiological Sigh",
          time: "flexible",
          icon: "💨",
          why: "Doppelter Einatem durch die Nase, langer Ausatem durch den Mund. Eine Stanford-RCT (2023) zeigte ihn als effektivste Methode zur sofortigen Stress-Reduktion — besser als Box Breathing und Meditation. Der verlängerte Ausatem aktiviert den Vagusnerv messbar.",
          source: "Balban et al., Cell Reports Medicine, 2023 · Huberman Lab, Episode 54",
          dose: "5 Minuten täglich oder bei akutem Stress: 1–3 Wiederholungen",
        },
        {
          id: "hab_box_breathing",
          label: "Box Breathing (4-4-4-4)",
          time: "flexible",
          icon: "📦",
          why: "Box Breathing ist eine einfache Atemübung mit gleichmäßigem Rhythmus.",
          source: "Zaccaro et al., Frontiers in Human Neuroscience, 2018",
          dose: "5 Minuten täglich oder vor stressigen Situationen — 4 Runden Box Breathing",
        },
      ],
    },
    {
      id: "mind_journaling",
      label: "Journaling",
      icon: "📓",
      habits: [
        {
          id: "hab_gratitude",
          label: "Dankbarkeits-Journal (3 Dinge)",
          time: "night",
          icon: "🙏",
          why: "Regelmäßig drei Dinge zu notieren, für die man dankbar ist, war in Studien mit höherem Wohlbefinden verbunden.",
          source: "Seligman et al., American Psychologist, 2005 · Emmons & McCullough, JPSP, 2003",
          dose: "3 spezifische Dinge täglich, abends — Handschrift wirksamer als digital",
        },
        {
          id: "hab_morning_pages",
          label: "Morning Pages (freies Schreiben)",
          time: "morning",
          icon: "✍️",
          why: "3 Seiten freies Schreiben direkt nach dem Aufwachen kann helfen, kreisende Gedanken zu sortieren. Expressives Schreiben war in Studien mit geringerem Stresserleben verbunden.",
          source: "Pennebaker & Smyth, Opening Up by Writing It Down, 2016",
          dose: "3 Seiten handgeschrieben, direkt nach dem Aufwachen, ohne Zensur",
        },
        {
          id: "hab_weekly_review",
          label: "Wöchentliches Review",
          time: "flexible",
          icon: "📋",
          why: "Das wöchentliche Review — popularisiert durch David Allens Getting Things Done — schließt offene Schleifen im Arbeitsgedächtnis, die sonst als kontinuierlicher kognitiver Hintergrundlärm mentale Kapazität verbrauchen. Studien zu 'Zeigarnik-Effekt' zeigen dass unabgeschlossene Aufgaben aktiv Gehirnressourcen belegen.",
          source: "Allen D., Getting Things Done, 2001 · Zeigarnik BV, Psychologische Forschung, 1927",
          dose: "60 Min. jeden Sonntag: Inbox Zero, Aufgaben reviewen, nächste Woche planen",
        },
      ],
    },
    {
      id: "mind_focus",
      label: "Fokus & Deep Work",
      icon: "🎯",
      habits: [
        {
          id: "hab_deep_work",
          label: "90-Min. Deep Work Block",
          time: "morning",
          icon: "🎯",
          why: "Ultradian-Rhythmen — 90-Minuten-Zyklen — sind die natürliche Einheit für konzentrierte Arbeit. Huberman empfiehlt einen täglichen Block in den ersten 4–6 Stunden nach dem Aufwachen wenn Cortisol und Dopamin natürlich erhöht sind.",
          source: "Huberman Lab, Episode 39 · Newport C., Deep Work, 2016",
          dose: "1 Block à 90 Min. täglich — Telefon weg, Notifications aus, eine Aufgabe",
        },
        {
          id: "hab_no_phone_morning",
          label: "Kein Handy erste 60 Min.",
          time: "morning",
          icon: "📵",
          why: "Das sofortige Checken von Nachrichten am Morgen versetzt das Gehirn in einen reaktiven Modus bevor er die Chance hat in einen fokussierten Zustand zu kommen. Dopamin wird durch sofortige Belohnungen konditioniert, was Toleranz für langfristige Aufgaben reduziert.",
          source: "Huberman Lab, Episode 1 · Price C., How to Break Up with Your Phone, 2018",
          dose: "Erstes Handy-Check frühestens 60 Min. nach dem Aufwachen",
        },
      ],
    },
  ],
};


// ============================================================
// HABIT OS — Bibliothek: Sleep
// ============================================================

export const LIBRARY_SLEEP = {
  id: "sleep",
  label: "Sleep",
  icon: "😴",
  subcategories: [
    {
      id: "sleep_light",
      label: "Licht & Zirkadianrhythmus",
      icon: "💡",
      habits: [
        {
          id: "hab_morning_light",
          label: "Morgendliches Sonnenlicht (10–30 Min.)",
          time: "morning",
          icon: "🌅",
          why: "Sonnenlicht in den ersten 30–60 Minuten stoppt Melatonin-Produktion, setzt einen gesunden Cortisol-Puls und startet einen 12–16-Stunden-Timer für die abendliche Melatonin-Ausschüttung. Huberman: 'Die wirksamste und kostenloseste Intervention für Schlaf, Stimmung und Energie.'",
          source: "Huberman Lab, Episode 1 · Leproult & Van Cauter, JAMA, 2011",
          dose: "10–30 Min. draußen direkt nach dem Aufwachen, keine Sonnenbrille",
        },
        {
          id: "hab_evening_dim",
          label: "Dimmes Licht ab 21 Uhr",
          time: "night",
          icon: "🕯️",
          why: "Helles Bildschirmlicht am Abend kann das Einschlafen erschweren. Licht ab 21 Uhr dimmen.",
          source: "Chang et al., PNAS, 2015 · Walker M., Why We Sleep, 2017",
          dose: "Ab 21 Uhr: Bildschirme auf minimum, Deckenlampen aus, Stehlampen bevorzugen",
        },
      ],
    },
    {
      id: "sleep_temperature",
      label: "Temperatur & Umgebung",
      icon: "🌡️",
      habits: [
        {
          id: "hab_room_temp",
          label: "Schlafzimmer auf 18–19°C",
          time: "night",
          icon: "❄️",
          why: "Die Kernkörpertemperatur muss für den Schlaf-Onset um 1–3°C sinken. Matthew Walker bezeichnet 18,3°C als optimale Schlaftemperatur. Zu warme Zimmer reduzieren Tiefschlaf-Anteil messbar.",
          source: "Walker M., Why We Sleep, 2017 · Okamoto-Mizuno & Mizuno, Journal of Physiological Anthropology, 2012",
          dose: "18–19°C Raumtemperatur, leichte Decke",
        },
        {
          id: "hab_consistent_sleep",
          label: "Feste Schlaf- und Aufwachzeit",
          time: "night",
          icon: "⏰",
          why: "Konsistenz der Schlafzeiten ist wichtiger als die Gesamtschlafdauer. Variation von nur 30–60 Min. stört den zirkadianen Rhythmus ähnlich wie wöchentlicher Jetlag.",
          source: "Walker M., Why We Sleep, 2017 · Phillips et al., Science Advances, 2017",
          dose: "Selbe Schlaf- und Aufwachzeit ±30 Min., auch am Wochenende",
        },
      ],
    },
    {
      id: "sleep_supplements",
      label: "Schlaf-Supplemente",
      icon: "💊",
      habits: [
        {
          id: "hab_melatonin_low",
          label: "Niedrig-Dosis Melatonin",
          time: "night",
          icon: "🌙",
          why: "Melatonin ist ein körpereigenes Hormon. Vor der Einnahme von Melatonin-Präparaten ärztlich beraten lassen.",
          source: "Vural et al., Journal of Clinical Sleep Medicine, 2014 · Huberman Lab, Sleep Toolkit",
          dose: "Höchstens 1 mg laut Herstellerangabe, nicht dauerhaft ohne ärztliche Rücksprache. Nicht in Schwangerschaft, Stillzeit oder bei Kindern.",
        },
        {
          id: "hab_theanine",
          label: "L-Theanin",
          time: "night",
          icon: "🍵",
          why: "L-Theanin erhöht Alpha-Gehirnwellen und GABA, erzeugt Entspannung ohne Schläfrigkeit und reduziert 'Racing Thoughts'. Huberman kombiniert es mit Magnesium L-Threonat und Apigenin als persönlichen Schlaf-Stack.",
          source: "Hidese et al., Nutrients, 2019 · Huberman Lab, Sleep Toolkit",
          dose: "Laut Herstellerangabe, 30–60 Min. vor dem Schlafen",
        },
        {
          id: "hab_glycine_sleep",
          label: "Glycin",
          time: "night",
          icon: "💤",
          why: "Glycin ist eine hemmende Aminosäure die Körperkerntemperatur senkt (durch Vasodilatation an den Extremitäten) — genau den Mechanismus der für Schlaf-Onset nötig ist. Studien zeigen verbesserte Schlafqualität, weniger Tagesmüdigkeit und schnelleres Einschlafen. Gleichzeitig ein wichtiger Ko-Faktor für Kollagen-Synthese.",
          source: "Bannai et al., Sleep and Biological Rhythms, 2012 · Inagawa et al., Sleep and Biological Rhythms, 2006",
          dose: "Laut Herstellerangabe, 30–60 Min. vor dem Schlafen — in Wasser oder Tee auflösen",
        },
      ],
    },
  ],
};


// ============================================================
// HABIT OS — Bibliothek: Food & Ernährung
// ============================================================

export const LIBRARY_FOOD = {
  id: "food",
  label: "Food",
  icon: "🥗",
  subcategories: [
    {
      id: "food_protein",
      label: "Protein",
      icon: "🥩",
      habits: [
        {
          id: "hab_protein_target",
          label: "Ausreichend Protein über den Tag verteilen",
          time: "flexible",
          icon: "🥩",
          why: "Protein ist wichtig für Muskelaufbau. Der Bedarf ist individuell und steigt mit Training und Alter.",
          source: "Attia P., Outlive, 2023 · Lyon G., Forever Strong, 2023",
          dose: "Proteinquellen auf die Mahlzeiten verteilen. Sehr hohe Mengen oder Nierenerkrankungen vorher ärztlich abklären.",
        },
        {
          id: "hab_protein_morning",
          label: "Proteinreiches Frühstück",
          time: "morning",
          icon: "🥚",
          why: "Proteinreiches Frühstück reduziert Heißhunger am Nachmittag messbar, stabilisiert Blutzucker und liefert Aminosäuren für Dopamin- und Serotonin-Synthese.",
          source: "Leidy et al., American Journal of Clinical Nutrition, 2013",
          dose: "Eine proteinreiche Komponente zum Frühstück, z. B. Eier oder Joghurt.",
        },
      ],
    },
    {
      id: "food_timing",
      label: "Meal Timing",
      icon: "⏰",
      habits: [
        {
          id: "hab_trf",
          label: "Time-Restricted Feeding (10–12 Std.)",
          time: "flexible",
          icon: "🕐",
          why: "Beim zeitlich begrenzten Essen werden alle Mahlzeiten in einem festen Tagesfenster gegessen.",
          source: "Wilkinson et al., Cell Metabolism, 2020 · Panda S., The Circadian Code, 2019",
          dose: "Essensfenster von etwa 10–12 Stunden. Bei Diabetes, Schwangerschaft, Essstörungen oder Medikamenten vorher ärztlich abklären.",
        },
        {
          id: "hab_no_eating_before_bed",
          label: "3 Stunden vor Schlaf nichts essen",
          time: "night",
          icon: "🌙",
          why: "Spätes Essen erhöht Kernkörpertemperatur, unterdrückt Wachstumshormon-Ausschüttung und führt zu schlechterer Schlafqualität und höherer Nüchternglukose am nächsten Morgen.",
          source: "Chung et al., Journal of Clinical Sleep Medicine, 2020",
          dose: "Letzte Mahlzeit mindestens 3 Stunden vor dem Schlafengehen",
        },
      ],
    },
    {
      id: "food_antiinflammatory",
      label: "Beeren & Öle",
      icon: "🫐",
      habits: [
        {
          id: "hab_berries_daily",
          label: "Beeren täglich (150 g+)",
          time: "flexible",
          icon: "🫐",
          why: "Beeren liefern Ballaststoffe, Vitamin C und Anthocyane.",
          source: "Devore et al., Annals of Neurology, 2012 · Cassidy et al., American Journal of Clinical Nutrition, 2011",
          dose: "150–200 g täglich, frisch oder tiefgekühlt (gleicher Nährwert)",
        },
        {
          id: "hab_olive_oil",
          label: "Olivenöl extra vergine (täglich)",
          time: "flexible",
          icon: "🫒",
          why: "Natives Olivenöl extra ist ein zentraler Bestandteil der mediterranen Küche.",
          source: "Estruch et al., NEJM, 2013 · Beauchamp et al., Nature, 2005",
          dose: "3–4 EL täglich extra vergine Olivenöl — roh, nie zum Hocherhitzen",
        },
        {
          id: "hab_no_seed_oils",
          label: "Raps- und Olivenöl als Alltagsöle",
          time: "flexible",
          icon: "🚫",
          why: "Raps- und Olivenöl sind gute Alltagsöle, Sonnenblumen- und Maisöl eher sparsam verwenden.",
          source: "Simopoulos AP, Biomedicine & Pharmacotherapy, 2002 · Attia P., Outlive, 2023",
          dose: "Olivenöl für Salate und sanftes Garen, Rapsöl zum Kochen und Braten",
        },
      ],
    },
  ],
};